import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetContacts = ({
    domain,
    search,
    enabled = true,
    limit,
}: {
    domain: string;
    search?: string;
    enabled?: boolean;
    limit?: number;
}) => {
    return useQuery({
        queryKey: aiAgentQueryKeys.contacts(domain, search, limit),
        queryFn: async ({ signal }) =>
            await salesApiService.aiAgent.meeting.getContacts(
                { domain, search: search?.trim(), limit },
                { cancellation: signal },
            ),
        enabled: !!domain && enabled,
    });
};
